export default [
    {
        value: 1,
        text: "ჭამის წინ"
    },
    {
        value: 2,
        text: "ჭამის შემდეგ"
    },
    {
        value: 3,
        text: "უზმოზე"
    },
    {
        value: 4,
        text: "ძილის წინ"
    },
    {
        value: 5,
        text: "სიმპტომურად"
    }
]